import { FetchPolicy } from '@apollo/client'
import { useProductClassesQuery } from '../../../../graphql'

export default function useProductClassesSearch( search: string, debounceKey = 'providersQuery-debounce' ) {
	const queryParams = {
		context: { debounceKey },
		fetchPolicy: 'no-cache' as FetchPolicy,
		variables: { search },
	}

	return useProductClassesQuery( queryParams )
}
